import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export default function MatkaPaymentSuccessModal({
  show,
  onClose,
  amount = 1000,
  oldBalance = 0,
  newBalance = 1000,
}) {
  // Prevent background scrolling when modal is open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);

  if (!show) return null;

  const displayAmount =
    typeof amount === "number" ? amount.toLocaleString() : amount;
  const displayNewBalance =
    typeof newBalance === "number" ? newBalance.toLocaleString() : newBalance;
  const displayOldBalance =
    typeof oldBalance === "number" ? oldBalance.toLocaleString() : oldBalance;

  const modalContent = (
    <div
      className="matka-payment-modal-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999999,
        background: "rgba(0, 0, 0, 0.78)",
        backdropFilter: "blur(5px)",
        WebkitBackdropFilter: "blur(5px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <div
        className="matka-payment-modal-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          zIndex: 10000000,
        }}
      >
        {/* Close Button */}
        <button
          type="button"
          className="matka-payment-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>

        {/* Success Check Icon */}
        <div className="matka-payment-success-icon-wrapper">
          <div className="matka-payment-success-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        </div>

        {/* Title */}
        <h3 className="matka-payment-success-title">Payment Success!</h3>

        {/* Subtitle with dynamic amount */}
        <p className="matka-payment-success-subtitle">
          A payment of <strong>₹{displayAmount}</strong> has been done
          successfully.
        </p>

        {/* Wallet Balance Summary Cards */}
        <div className="matka-payment-balance-grid">
          {/* Old Wallet Balance */}
          <div className="matka-balance-card">
            <div className="matka-balance-icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#9aa0a6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div className="matka-balance-info">
              <span className="matka-balance-amount">₹{displayOldBalance}</span>
              <span className="matka-balance-label">Old Wallet Balance</span>
            </div>
          </div>

          {/* New Wallet Balance */}
          <div className="matka-balance-card">
            <div className="matka-balance-icon">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#9aa0a6"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div className="matka-balance-info">
              <span className="matka-balance-amount">₹{displayNewBalance}</span>
              <span className="matka-balance-label">New Wallet Balance</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (typeof document !== "undefined" && document.body) {
    return ReactDOM.createPortal(modalContent, document.body);
  }

  return modalContent;
}
